import React, {PureComponent} from "react";
import {Field, reduxForm} from 'redux-form';
import validate from "./activateCdiValidate.js"
import CardRow from "../../Styled/Card/CardRow.jsx";
import CardCol from "../../Styled/Card/CardCol.jsx";
import Date from "../../Form/Field/Date.jsx";
import Input from "../../Form/Field/Input.jsx";


export const name = 'ActivateCdiForm'
class ActivateCdiForm extends PureComponent {
  render() {
    return (
      <div id={name}>
        <form
          autoComplete="off"
          onSubmit={(e) => {
            return
          }}
        >
          <CardRow gap="10px" className="pb-5">
            <CardCol>
              <label htmlFor="">
                Date de démarrage *
              </label>
              <Field
                label={null}
                name="freelance.date_cdi_start"
                placeholder="JJ/MM/AAAA"
                type="text"
                component={Date}
              />
            </CardCol>
            <CardCol>
              <label htmlFor="">
                Entreprise
              </label>
              <Field
                label={null}
                name="user.company"
                type="text"
                component={Input}
              />
            </CardCol>
            <CardCol>
              <label htmlFor="">
                Titre du poste
              </label>
              <Field
                label={null}
                name="freelance.title"
                type="text"
                component={Input}
              />
            </CardCol>
          </CardRow>
        </form>
      </div>
    );
  }
}

let ReduxActivateCdiForm = reduxForm({
  form: name,
  validate,
})(ActivateCdiForm);

export default ReduxActivateCdiForm